import { enablePowerIcon } from '../state/ui-store';

export const enablePowerBttn = () => enablePowerIcon();
